<section>
  <h4 class="page-title" *ngIf="showTitle">Calendar</h4>
  <kendo-card width="100%">
    <div class="content-wrapper">
      <app-calendar-filters *ngIf="showFilters" [filters]="filters" (applyFilter)="onApplyFilter($event)"
        (clearFilter)="onClearFilter()" (distanceSelectionChange)="onDistanceSelectionChange($event)">
      </app-calendar-filters>
      <app-user-calendar [userIds]="userIds" [additionalFilters]="filters" [distanceSelection]="distanceSelection"
        [showFilters]="showFilters" (loadingChange)="calendarLoading = $event">
      </app-user-calendar>
    </div>
  </kendo-card>
</section>